import styled from 'styled-components';

export const StyledMedicineReimbursementSelector = styled.div`
   display: flex;
   flex-wrap: wrap;
   margin-left: -6px;
   gap: 8px;
   padding-top: 4px;
`;
StyledMedicineReimbursementSelector.displayName = 'StyledMedicineReimbursementSelector';

export const StyledMedicineReimbursementAddIcon = styled.div`
   display: none;
   position: absolute;
   top: 1px;
   right: 1px;
   bottom: 0;
   height: 16px;
   width: 16px;
`;
StyledMedicineReimbursementAddIcon.displayName = 'StyledMedicineReimbursementAddIcon';
